import Entity from '../entity';
import Decimal from 'decimal.js';
export default class ItemTrees extends Entity<number>{
    Id: string;
    label: string;
    acctId:string;
    parentId: string;
    headUrl: string;
    isSelect: any;
    userId: string;
    roleId: string;
    roleName: string;
    planHours: Decimal;
    updateTime:string;
    isFocus: boolean;
    children: Array<ItemTrees>;
}